import { client } from './API';
import { User } from '@/models/permission/AuthorityModel';
import { ENVIRONMENTAL_VARIABLES } from '@/utils/Environment';

export function fetchCurrentUserProfile({ communityId }: { communityId: string }): Promise<User> {
  return client
    .get(`${ENVIRONMENTAL_VARIABLES.API_ALFRESCO_URL}/${communityId}/users/-me-`)
    .then((response) => response.data);
}
